import {styled, TableCell, tableCellClasses, TableRow} from "@mui/material";
import MuiAccordion, {AccordionProps} from "@mui/material/Accordion";
import MuiAccordionSummary, {AccordionSummaryProps} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import React from "react";

export const DrillTableHeaderCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 12,
        lineHeight: "18px",
        fontWeight: 700,
        padding: 8
    }
}));

export const DrillTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
        lineHeight: "18px",
        padding: 8
    }
}));

export const DrillTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(even)': {
        backgroundColor: "#FCFAFA",
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    }
}));

export const DrillAccordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
    border: "2px solid #E5E5E5",
    '&:before': {
        display: 'none',
    },
}));

export const DrillAccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary {...props}/>
))(({theme}) => ({
    '& .MuiAccordionSummary-expandIconWrapper': {
        marginTop: "auto",
        paddingLeft: "10px"
    },
    '& .Mui-expanded': {
        paddingLeft: 0,
        paddingRight: "5px"
    },
    '& .MuiSvgIcon-root ': {
        fontSize: "30px"
    },
    padding: "15px",
    width: "100%",
    margin: 0,
    '& .MuiAccordionSummary-content': {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        margin: "0",
        overflow: "auto"
    }
}));

export const DrillAccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));